<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <h2 class="hakotan_title">プライバシーポリシー</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="tokutei">
          <section>
            <div class="corp_table" ref="corp_yasumoku">
              <ul class="ul_corp_outline">
                <li>
                  <div>はじめに</div>
                  <div>株式会社ヤスモク（以下「当社」）は、個人情報保護の重要性を認識し、適切に利用し、保護することが社会的責任であると考え、個人情報の保護に努めることをお約束いたします。</div>
                </li>
                <li>
                  <div>個人情報の定義</div>
                  <div>個人情報とは、個人に関する情報であり、氏名、生年月日、性別、電話番号、電子メールアドレス、職業、勤務先等、特定の個人を識別し得る情報をいいます。</div>
                </li>
                <li>
                  <div>個人情報の収集・利用</div>
                  <div>
                    当社は、以下の目的のため、その範囲内においてのみ、個人情報を収集・利用いたします。<br>
                    当社による個人情報の収集・利用は、お客様の自発的な提供によるものであり、お客様が個人情報を提供された場合は、当社が本方針に則って個人情報を利用することをお客様が許諾したものとします。<br>
                    ・ご注文された当社の商品をお届けするうえで必要な業務<br>
                    ・新商品の案内など、お客様に有益かつ必要と思われる情報の提供<br>
                    ・業務遂行上で必要となる当社からの問い合わせ、確認、およびサービス向上のための意見収集<br>
                    ・不正・不当な目的で当社を利用しようとする方のご利用をお断りするために行う調査<br>
                    ・当社及び当社の提携先が提供しているサービスやセキュリティの向上<br>
                    ・各種のお問い合わせ対応
                  </div>
                </li>
                <li>
                  <div>個人情報の第三者提供</div>
                  <div>当社は、法令に基づく場合等正当な理由によらない限り、事前に本人の同意を得ることなく、個人情報を第三者に開示・提供することはありません。</div>
                </li>
                <li>
                  <div>委託先の監督</div>
                  <div>当社は、お客様へ商品やサービスを提供する等の業務遂行上、個人情報の一部を外部の委託先へ提供する場合があります。その場合、業務委託先が適切に個人情報を取り扱うように管理いたします。</div>
                </li>
                <li>
                  <div>個人情報の管理</div>
                  <div>当社は、個人情報の漏洩、滅失、毀損等を防止するために、個人情報保護管理責任者を設置し、十分な安全保護に努め、また、個人情報を正確に、また最新なものに保つよう、お預かりした個人情報の適切な管理を行います。</div>
                </li>
                <li>
                  <div>クッキーについて</div>
                  <div>当ウェブサイトでは、クッキーを商品の購入、利用者の動向調査等の為に使用することがあります。お客様がクッキーを使用しない設定としている場合、当ウェブサイトで使用できる機能については制限される可能性がありますのでご了承下さい。</div>
                </li>
                <li>
                  <div>情報内容の照会、修正または削除</div>
                  <div>当社は、お客様が当社にご提供いただいた個人情報の照会、修正または削除を希望される場合は、ご本人であることを確認させていただいたうえで、合理的な範囲ですみやかに対応させていただきます。</div>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcTokukei',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'toukei', key: 'dcTokutei', title: '特定商取引法の表示', route: 'DcTokutei'}
      ]
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    scrollToAnchorPoint: function (refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({behavior: 'smooth'})
    }
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcPrivacyPolicy.vue